import { useNavigate } from "react-router-dom";
import { useState } from "react";

import { T } from "@repo/transifex";
import { MembersGridLayout } from "~/components/collect/members-grid";
import { SearchPageLayout } from "~/components/search-page-layout";
import { employeeActions } from "~/providers/store/employee";
import { useCurrentSchool } from "~/hooks/queries/schools";

export const PosSearchGroupPage = () => {
  const navigate = useNavigate();

  const [searchQuery, setSearchQuery] = useState("");

  const {
    data: groups,
    isFetching,
    isError,
    refetch
  } = useCurrentSchool((data) => {
    if (searchQuery.length === 0) return data.groupNames;

    return data.groupNames.filter((groupName) =>
      groupName.toLowerCase().includes(searchQuery.toLowerCase())
    );
  });

  return (
    <SearchPageLayout
      onBack={() => {
        navigate(-1);
      }}
      isLoading={isFetching}
      isError={isError}
      data={groups}
      onSearch={setSearchQuery}
      onRetry={refetch}
      renderItem={(item) => (
        <MembersGridLayout.Link
          to="/pos/sell"
          member={item}
          key={item}
          onClick={() => {
            employeeActions.setAuthEmployee({
              groupName: item,
              employeeChildId: null // clear any selected child
            });
          }}
        />
      )}
      emptyStateMessage={<T _str="Start typing to search for a group..." />}
      noResultsMessage={
        <T _str="No groups found. Try adjusting your search." />
      }
    />
  );
};
